<template>
	<v-tabs
		color="background darken-1"
		v-model="current_tab"
		icons-and-text>
		<v-tabs-slider color="primary"></v-tabs-slider>

		<v-tab href="#tab-info">
			Informations
			<v-icon>help</v-icon>
		</v-tab>

		<v-tab href="#tab-qc" :disabled="disable_qc">
			QC
			<v-icon>thumbs_up_down</v-icon>
		</v-tab>

		<v-tab href="#tab-artefacts" :disabled="!artefacts">
			Artefacts
			<v-icon>auto_awesome_motion</v-icon>
		</v-tab>

		<v-tab href="#tab-locations" :disabled="locations.length === 0">
			Emplacements
			<v-icon>find_in_page</v-icon>
		</v-tab>

		<v-tab href="#tab-metadata" :disabled="disable_babel">
			Editorial
			<v-icon>assignment</v-icon>
		</v-tab>

		<v-tab href="#tab-debug">
			Data
			<v-icon>code</v-icon>
		</v-tab>

		<v-tab-item value="tab-info">
			<v-card flat class="background darken-1">
				<v-card-text>
					<v-layout row wrap>
						<v-flex shrink class="pr-5">
							<table>
								<tbody>
									<tr>
										<td colspan="2" class="title primary--text pb-3">
											Général
										</td>
									</tr>
									<tr>
										<th>Ayant-droit</th>
										<td>
											<v-chip label small color="background" class="ma-0">
												{{ getter('t_aux.name') }}
											</v-chip>
										</td>
									</tr>
									<tr>
										<th>ID</th>
										<td>
											<a :href="behive_url" target="_blank">
												<v-icon small color="primary">open_in_new</v-icon>
												{{ getter('id') }}
											</a>
										</td>
									</tr>
									<tr>
										<th>Référence labo</th>
										<td>
											<v-btn
												small flat
												class="ma-0"
												color="primary"
												@click="copyToClipboard(getter('ref_material'))">
												{{ getter('ref_material') }}
												<v-icon small class="ml-2">content_copy</v-icon>
											</v-btn>
										</td>
									</tr>
									<tr>
										<th>Type de support</th>
										<td>{{ getter('type_sup.lib_type_sup') }}</td>
									</tr>
									<tr>
										<th>Poids</th>
										<td>{{ weight }}</td>
									</tr>
									<tr>
										<th>Type de stockage</th>
										<td>{{ getter('behive_category') }}</td>
									</tr>
									<tr>
										<th>Dernière mise à jour</th>
										<td>{{ update_date }}</td>
									</tr>
									<tr>
										<th>Origine</th>
										<td>{{ getter('origin') }}</td>
									</tr>
									<tr>
										<th>Proxy</th>
										<td class="py-0">
											<v-icon
												v-if="getter('has_proxy') === true"
												color="success lighten-1">
												check
											</v-icon>
											<v-icon
												v-else
												color="error lighten-1">
												block
											</v-icon>
										</td>
									</tr>
									<tr>
										<th>Rapport de Vérif</th>
										<td class="py-0">
											<v-icon
												v-if="getter('has_rv') === true"
												color="success lighten-1">
												check
											</v-icon>
											<v-icon
												v-else
												color="error lighten-1">
												block
											</v-icon>
										</td>
									</tr>
								</tbody>
							</table>
						</v-flex>
						<v-flex shrink>
							<table>
								<tbody>
									<tr>
										<td colspan="2" class="title primary--text pb-3">
											Programme
										</td>
									</tr>
									<tr>
										<th>Titre</th>
										<td>{{ getter('title.name') }}</td>
									</tr>
									<tr>
										<th>Titre secondaire</th>
										<td>{{ getter('title.alternative') }}</td>
									</tr>
									<tr>
										<th>Version Programme</th>
										<td>{{ getter('program.version') }}</td>
									</tr>
									<tr>
										<th>Type Programme</th>
										<td>{{ getter('program.type_prgm.lib_type_prgm') }}</td>
									</tr>
									<tr v-if="asset.program.no_episode">
										<th>N° Episode</th>
										<td>{{ getter('program.no_episode') }}</td>
									</tr>
									<tr v-if="asset.program.titre_epis_princ">
										<th>TItre Episode</th>
										<td>{{ getter('program.titre_epis_princ') }}</td>
									</tr>
									<tr v-if="asset.program.serie">
										<th>Série ID</th>
										<td>{{ getter('program.serie.serie_id') }}</td>
									</tr>
									<tr v-if="asset.program.serie">
										<th>Série N° Année</th>
										<td>{{ getter('program.serie.no_annee') }}</td>
									</tr>
									<tr v-if="asset.program.serie">
										<th>Série Titre ID</th>
										<td>{{ getter('program.serie.titre_id') }}</td>
									</tr>
								</tbody>
							</table>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-tab-item>

		<v-tab-item value="tab-qc">
			<v-card flat class="background darken-1">
				<v-card-text>
					<v-layout row wrap>
						<div class="title primary--text pa-2 pl-4">Info de mise à jour</div>
						<div class="pa-2">{{ getter('qc.update_info') }}</div>
					</v-layout>
					<v-divider class="primary mt-1"></v-divider>
					<v-layout row wrap>
						<v-flex shrink class="pr-5">
							<table>
								<tbody>
									<tr>
										<td colspan="2" class="title primary--text pb-3">
											Général
										</td>
									</tr>
									<tr v-for="(value, key) in asset.qc.general" :key="key">
										<th class="text-capitalize">{{ keyFormatter(key) }}</th>
										<td>{{ value || '-' }}</td>
									</tr>
								</tbody>
							</table>
						</v-flex>
						<v-flex shrink class="pr-5">
							<table>
								<tbody>
									<tr>
										<td colspan="2" class="title primary--text pb-3">
											Display
										</td>
									</tr>
									<tr v-for="(value, key) in asset.qc.display" :key="key">
										<th class="text-capitalize">{{ keyFormatter(key) }}</th>
										<td>
											<span v-if="key === 'aspect_ratio'">
												{{ (value||{}).label }} - {{ (value||{}).rounded }}
											</span>
											<span v-else-if="key === 'surface'">
												<div>
													border: {{ (value||{}).border }}%
												</div>
												<div>
													picture: {{ (value||{}).picture }}%
												</div>
											</span>
											<span v-else>
												{{ value || '-' }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</v-flex>
						<v-flex shrink class="pr-5">
							<table>
								<tbody>
									<tr>
										<td colspan="2" class="title primary--text pb-3">
											Picture
										</td>
									</tr>
									<tr>
										<th>Width</th>
										<td>{{ getter('qc.picture.width') }}</td>
									</tr>
									<tr>
										<th>Height</th>
										<td>{{ getter('qc.picture.height') }}</td>
									</tr>
									<tr>
										<th>Aspect ratio</th>
										<td>{{ getter('qc.picture.aspect_ratio.rounded') }}</td>
									</tr>
								</tbody>
							</table>
						</v-flex>
						<v-flex shrink class="pr-5">
							<table>
								<tbody>
									<tr>
										<td colspan="2" class="title primary--text pb-3">
											Validation
										</td>
									</tr>
									<tr>
										<th>Validé</th>
										<td>
											<v-icon
												v-if="getter('qc.validation.validated') === true"
												color="success lighten-1">
												check
											</v-icon>
											<v-icon
												v-else
												color="error lighten-1">
												block
											</v-icon>
										</td>
									</tr>
									<tr>
										<th>Commentaire</th>
										<td>{{ getter('qc.validation.comment') }}</td>
									</tr>
								</tbody>
							</table>
						</v-flex>
						<v-flex shrink class="pr-5" v-if="audio_channels.length > 0">
							<table>
								<tbody>
									<tr>
										<td colspan="2" class="title primary--text pb-3">
											Audio
										</td>
									</tr>
									<tr>
										<th>Source</th>
										<th>Type</th>
										<th>Langue</th>
										<th>Mix</th>
										<th>Mapping</th>
										<th>Norme</th>
										<th>Codec</th>
										<th>Dial norm</th>
										<th>Loudness algo</th>
										<th>Loudness</th>
										<th>Lra</th>
										<th>True peak</th>
									</tr>
									<tr
										v-for="(channel, i) in audio_channels"
										:key="'content' + i">
										<td>{{ channel.src_index }}</td>
										<td>{{ channel.version_type || '-' }}</td>
										<td>{{ channel.language || '-' }}</td>
										<td>{{ channel.mix_type || '-' }}</td>
										<td>{{ channel.mapping || '-' }}</td>
										<td>{{ channel.norm || '-' }}</td>
										<td>{{ channel.codec || '-' }}</td>
										<td>{{ channel.dial_norm || '-' }}</td>
										<td>{{ channel.loudness_algo || '-' }}</td>
										<td>{{ channel.loudness || '-' }}</td>
										<td>{{ channel.lra || '-' }}</td>
										<td>{{ channel.true_peak || '-' }}</td>
									</tr>
								</tbody>
							</table>
						</v-flex>
						<v-flex shrink class="pr-5" v-if="program_content.length > 0">
							<table>
								<tbody>
									<tr>
										<td colspan="2" class="title primary--text pb-3">
											Contenu
										</td>
									</tr>
									<tr>
										<th>Désignation</th>
										<th>Description</th>
										<th>Début</th>
										<th>Fin</th>
										<th>Durée</th>
										<th>Localisation</th>
										<th>Partie</th>
									</tr>
									<tr
										v-for="(content, i) in program_content"
										:key="'content' + i">
										<td>{{ content.designation || '-' }}</td>
										<td>{{ content.description || '-' }}</td>
										<td>{{ content.tc_in || '-' }}</td>
										<td>{{ content.tc_out || '-' }}</td>
										<td>{{ content.duration || '-' }}</td>
										<td>{{ content.localization || '-' }}</td>
										<td>{{ content.part || '-' }}</td>
									</tr>
								</tbody>
							</table>
						</v-flex>
					</v-layout>
				</v-card-text>
			</v-card>
		</v-tab-item>

		<v-tab-item value="tab-artefacts">
			<v-card flat class="background darken-1">
				<v-card-text v-if="artefacts">
					<v-container
						grid-list-md
						fluid
						class="pa-0"
						v-if="artefacts.screenshots.length">
						<v-layout row wrap>
							<v-flex
								v-for="(screenshot, i) in artefacts.thumbnails"
								:key="screenshot"
								xs4
								d-flex>
								<v-hover>
									<v-card
										flat tile
										class="d-flex"
										slot-scope="{ hover }"
										:class="`elevation-${hover ? 12 : 2}`">
										<v-img
											@click="openScreenshots(i)"
											:src="artefacts.url + screenshot + artefacts.signature"
											class="grey lighten-2">
											<template v-slot:placeholder>
												<v-layout
													fill-height
													align-center
													justify-center
													ma-0>
													<v-progress-circular
														indeterminate
														color="grey lighten-5">
													</v-progress-circular>
												</v-layout>
											</template>
											<v-expand-transition>
												<div
													v-if="hover"
													class="d-flex transition-fast-in-fast-out primary v-card--reveal"
													style="height: 100%;">
													<v-icon :size="100" color="color">fullscreen</v-icon>
												</div>
											</v-expand-transition>
										</v-img>
									</v-card>
								</v-hover>
							</v-flex>
						</v-layout>
					</v-container>
					<div id="screenshot-viewer"></div>
					<v-container
						grid-list-md
						fluid
						class="pa-0">
						<v-layout
							row wrap
							v-for="(val, key, i) in artefacts.audio"
							:key="'audio' + i">
							<div :id="`zoomview-${key}`" class="zoomview"></div>
							<div :id="`overview-${key}`" class="overview"></div>
							<audio
								:id="`audio-${key}`"
								controls
								:src="artefacts.url + val.wav + artefacts.signature">
							</audio>
						</v-layout>
					</v-container>
				</v-card-text>
			</v-card>
		</v-tab-item>

		<v-tab-item value="tab-locations">
			<v-card flat class="background darken-1">
				<v-card-text>
					<div
						v-for="(location, i) in locations"
						:key="'location_' + i"
						class="location"
						:style="`border: 1px solid var(--v-${location.color}-base)`">
						<div>
							<span v-if="is_admin">
								<v-btn small color="primary color--text" class="mt-0 ml-0"
									:href="`${t1000_url}${location.id}/change/`"
									target="_blank">
									<v-icon small color="color" class="mr-1">open_in_new</v-icon>
									#{{ location.id }}
								</v-btn>
							</span>
							<span v-else>
								<v-chip
									label small
									color="primary"
									text-color="color"
									class="mt-0 ml-0">
									#{{ location.id }}
								</v-chip>
							</span>
							<span class="pl-2">
								<v-chip label outline small class="mt-0 ml-0"
									:color="location.status === 1 ? 'green accent-3' : 'red accent-2'">
									{{ location.status_text }}
								</v-chip>
							</span>
							<span :title="$time.fromDate(location.creation_date)" class="pl-2">
								créée le {{ location.creation_date | formatDate2 }}
							</span>
							<span class="pl-2" v-if="location.creation_jobrequest">
								Via le job
								<router-link class="link"
									:to="{
										name: 'Maestro job',
										params: { jr_id: location.creation_jobrequest }
									}">
									<v-icon small>open_in_new</v-icon>
									{{ location.creation_jobrequest }}
								</router-link>
							</span>
							<span class="storage-category">
								<v-icon :size="200"
									:color="location.color">
									{{ location.icon }}
								</v-icon>
							</span>
						</div>

						<div class="pt-2">
							<span v-if="location.absolute_path.indexOf('/media/DATA/') === 0">
								<router-link class="link"
									:to="{
										name: 'Filesystem',
										query: { path: location.absolute_path }
									}">
									<v-icon small>open_in_new</v-icon>
									{{ location.absolute_path }}
								</router-link>
							</span>
							<span v-else>
								{{ location.absolute_path }}
							</span>
						</div>

						<div class="pt-2"
							:class="location.last_check_is_valid ?
							'green--text text--accent-3' :
							'red--text text--accent-2'">
							<span :title="$time.fromDate(location.last_check_date)">
								<v-icon
									v-if="location.last_check_is_valid"
									color="green accent-3"
									small
									class="mr-1">
									check_box
								</v-icon>
								<v-icon
									v-else
									color="red accent-2"
									small
									class="mr-1">
									block
								</v-icon>
								Dernière vérification
								<span v-if="location.last_check_date">
									le {{ location.last_check_date | formatDate2 }}
								</span>
								<span v-else>
									inconnue
								</span>
							</span>
						</div>

						<div class="pt-2">
							<span
								:class="location.is_nearline ?
								'green--text text--accent-3' :
								'red--text text--accent-2'">
								<v-icon
									v-if="location.is_nearline"
									color="green accent-3"
									small
									class="mr-1">
									check_box
								</v-icon>
								<v-icon
									v-else
									color="red accent-2"
									small
									class="mr-1">
									block
								</v-icon>
								Nearline
							</span>
						</div>

						<div class="pt-2">
							<span :title="$time.fromDate(location.deletion_date)">
								Suppression le
								<span class="pl-2">
									{{ location.deletion_date | formatDate2 }}
								</span>
							</span>
						</div>

						<div class="pt-2">
							<span :title="$time.fromDate(location.expiring.date)">
								Expire le
								<span class="pl-2">
									{{ location.expiring.date | formatDate2 }}
								</span>
							</span>
							<span class="pl-2" v-if="location.expiring.jobrequest_id">
								Via le job
								<router-link class="link"
									:to="{
										name: 'Maestro job',
										params: { jr_id: location.expiring.jobrequest_id }
									}">
									<v-icon small>open_in_new</v-icon>
									{{ location.expiring.jobrequest_id }}
								</router-link>
							</span>
							<span class="pl-2" v-if="location.expiring.jobdescriptor">
								Descripteur {{ location.expiring.jobdescriptor }}
							</span>
						</div>

						<div class="pt-2">
							<span>Stockage</span>
							<span>
								<v-icon small :color="location.color">
									{{ location.icon }}
								</v-icon>
							</span>
							<span :style="`color: var(--v-${location.color}-lighten1)`">
								{{ location.storage.category }}
								({{ location.storage.family }})
								{{ location.storage.name }}
								(#{{ location.storage.id }})
							</span>
						</div>

						<div class="pt-2" v-if="location.analysis">
							<div v-if="location.analysis.length">
								<span>
									Analyse
								</span>
								<span>
									<table>
										<tbody>
											<tr v-for="(analysis, index) in location.analysis"
												:key="'analysis_' + index">
												<td>{{ analysis.code }}</td>
												<td>{{ analysis.level }}</td>
												<td>{{ analysis.name }}</td>
											</tr>
										</tbody>
									</table>
								</span>
							</div>
						</div>
					</div>
				</v-card-text>
			</v-card>
		</v-tab-item>

		<v-tab-item value="tab-metadata">
			<v-card flat class="background darken-1">
				<v-card-text>
					<div v-for="(edito, i) in edito" :key="'edito' + i">
						<v-layout row wrap justify-center>
							<v-flex xs6 class="pr-0">
								<table>
									<tbody>
										<tr>
											<td colspan="4" class="title primary--text pb-3">
												{{ edito.card_type }}
											</td>
										</tr>
										<tr>
											<th>ID</th>
											<td>{{ edito.id }}</td>
										</tr>
										<tr>
											<th>Creation Date</th>
											<td>{{ edito.creation_date }}</td>
										</tr>
										<tr>
											<th>Last Update</th>
											<td>{{ edito.last_update }}</td>
										</tr>
										<tr>
											<th>Title</th>
											<td>{{ edito.title }}</td>
										</tr>
										<tr>
											<th>Title Language</th>
											<td>{{ edito.title_language }}</td>
										</tr>
										<tr>
											<th>Episode Num</th>
											<td>{{ edito.episode_num }}</td>
										</tr>
										<tr>
											<th>Duration</th>
											<td>{{ edito.duration }}</td>
										</tr>
										<tr>
											<th>Production Year</th>
											<td>{{ edito.production_year }}</td>
										</tr>
										<tr>
											<th>Type</th>
											<td>{{ edito.type }}</td>
										</tr>
										<tr>
											<th>Genre</th>
											<td>{{ edito.genre }}</td>
										</tr>
										<tr>
											<th>Target</th>
											<td>{{ edito.target }}</td>
										</tr>
										<tr>
											<th>Synopsis</th>
											<td>{{ edito.synopsis }}</td>
										</tr>
										<tr v-if="edito.casting.length > 0">
											<th>Casting</th>
											<td class="pa-0">
												<table>
													<tr
														v-for="(cast, i) in edito.casting"
														:key="'cast' + i">
														<th>{{ cast.role }}</th>
														<td>{{ cast.name }}</td>
													</tr>
												</table>
											</td>
										</tr>
									</tbody>
								</table>
							</v-flex>
							<v-flex xs6 class="pl-0">
								<table>
									<tbody>
										<tr>
											<td colspan="2" class="title primary--text pb-3">
												Localized Info
											</td>
										</tr>
										<tr
											v-for="(locale, i) in edito.localized_info"
											:key="'locale' + i">
											<th>
												<v-chip
													label
													color="primary color--text"
													class="font-weight-bold">
													{{ locale.language }}
												</v-chip>
											</th>
											<td class="pa-0">
												<table>
													<tr>
														<th>language</th>
														<td>{{ locale.language }}</td>
													</tr>
													<tr>
														<th>title</th>
														<td>{{ locale.title }}</td>
													</tr>
													<tr>
														<th>origin_country</th>
														<td>{{ locale.origin_country }}</td>
													</tr>
													<tr>
														<th>target</th>
														<td>{{ locale.target }}</td>
													</tr>
													<tr>
														<th>synopsis</th>
														<td>{{ locale.synopsis }}</td>
													</tr>
													<tr>
														<th>genre</th>
														<td>{{ locale.genre }}</td>
													</tr>
													<tr>
														<th>type</th>
														<td>{{ locale.type }}</td>
													</tr>
												</table>
											</td>
										</tr>
									</tbody>
								</table>
							</v-flex>
						</v-layout>
						<v-divider class="primary"></v-divider>
					</div>
					<div class="pa-2">
						<tree-view
							:data="asset.babel"
							:options="{maxDepth: 0, rootObjectKey: 'Données Brutes'}" />
					</div>
				</v-card-text>
			</v-card>
		</v-tab-item>

		<v-tab-item value="tab-debug">
			<v-card flat class="background darken-1">
				<v-card-text>
					<tree-view
						v-if="asset"
						:data="asset"
						:options="{maxDepth: 1, rootObjectKey: 'ASSET'}" />
				</v-card-text>
			</v-card>
		</v-tab-item>
	</v-tabs>
</template>

<script>
import Viewer from 'viewerjs'
import Peaks from 'peaks.js'
export default {
	props: [ 'asset', 'tab' ],
	components: { Viewer },
	data () {
		return {
			current_tab: null,
			artefacts: null,
			image_viewer: null,
			image_container: null
		}
	},
	watch: {
		asset (val) {
			this.fetchArtefacts()
		}
	},
	computed: {
		behive_url () {
			if (!this.asset) return false
			return `${window.appConfig._$ou3iju}dashboard/materials/${this.asset.id}`
		},
		t1000_url () {
			return `${window.appConfig._$jfjjm4}admin/asset/assetlocation/`
		},
		disable_qc () {
			if (!this.asset) return true
			return Object.keys(this.asset.qc).length === 0
		},
		disable_babel () {
			if (!this.asset) return true
			if (!this.asset.babel) return true
			return Object.keys(this.asset.babel).length === 0
		},
		update_date () {
			if (!this.asset) return '-'
			if (!this.asset._updated) return '-'
			return this.$time.humanizeDate(this.asset._updated)
		},
		weight () {
			if (!this.asset) return '-'
			if (!this.asset.asset_size) return '-'
			if (isNaN(parseInt(this.asset.asset_size))) return '-'
			if (String(this.asset.asset_size).length < 10) {
				return this.$weight.octalRoundToTwo(this.asset.asset_size, 2) + ' Mo'
			}
			if (String(this.asset.asset_size).length >= 10 &&
				String(this.asset.asset_size).length < 13) {
				return this.$weight.octalRoundToTwo(this.asset.asset_size, 3) + ' Go'
			}
			if (String(this.asset.asset_size).length >= 13 &&
				String(this.asset.asset_size).length < 16) {
				return this.$weight.octalRoundToTwo(this.asset.asset_size, 4) + ' To'
			}
			if (String(this.asset.asset_size).length >= 16) {
				return this.$weight.octalRoundToTwo(this.asset.asset_size, 5) + ' Po'
			}
		},
		program_content () {
			if (!this.asset) return '-'
			return this.$commons.deepGet(this.asset, 'qc.program_content', [])
		},
		audio_channels () {
			let channels = []
			if (!this.asset) return channels
			let audioVersions = this.$commons.deepGet(this.asset, 'qc.audio_mapping', [])
			audioVersions.map(version => {
				if (version.mix) {
					version.mix.map(mix => {
						if (mix.channel) {
							mix.channel.map(channel => {
								channels.push({
									version_type: version.type,
									language: version.language,
									lra: mix.lra,
									loudness_algo: mix.loudness_algo,
									dial_norm: mix.dial_norm,
									true_peak: mix.true_peak,
									codec: mix.codec,
									loudness: mix.loudness,
									mix_type: mix.type,
									norm: mix.norm,
									src_index: channel.src_index,
									mapping: channel.mapping
								})
							})
						}
					})
				}
			})
			return channels
		},
		edito () {
			let edito = []
			if (!this.asset) return edito
			if (!this.asset.babel) return edito
			if (!this.asset.babel.data) return edito
			let rootItem = {
				id: this.asset.babel.id || '-',
				card_type: this.asset.babel.sub_type || '-',
				creation_date: this.asset.babel.creation_date || '-',
				last_update: this.asset.babel.last_update || '-',
				title: this.asset.babel.title || '-',
				title_language: this.asset.babel.title_language || '-',
				episode_num: this.asset.babel.episode_num || '-',
				production_year: this.asset.babel.data.production_year || '-',
				target: this.asset.babel.data.target || '-',
				genre: this.asset.babel.data.genre || '-',
				type: this.asset.babel.data.type || '-',
				synopsis: this.asset.babel.data.synopsis || '-',
				duration: this.asset.babel.data.duration || '-',
				casting: this.asset.babel.data.casting || [],
				localized_info: []
			}
			if (this.asset.babel.data.localized_info) {
				this.asset.babel.data.localized_info.map(locale => {
					rootItem.localized_info.push({
						origin_country: locale.origin_country || '-',
						target: locale.target || '-',
						language: locale.language || '-',
						title: locale.title || '-',
						synopsis: locale.synopsis || '-',
						genre: locale.genre || '-',
						type: locale.type || '-'
					})
				})
			}
			edito.push(rootItem)
			if (this.asset.babel.parent) {
				let parent = this.asset.babel.parent
				let parentItem = {
					id: parent.id || '-',
					card_type: parent.card_type || '-',
					creation_date: parent.creation_date || '-',
					last_update: parent.last_update || '-',
					title: parent.title || '-',
					title_language: parent.title_language || '-',
					episode_num: parent.episode_num || '-',
					production_year: parent.data.production_year || '-',
					target: parent.data.target || '-',
					genre: parent.data.genre || '-',
					type: parent.data.type || '-',
					synopsis: parent.data.synopsis || '-',
					duration: parent.data.duration || '-',
					casting: parent.data.casting || [],
					localized_info: []
				}
				if (parent.data.localized_info) {
					parent.data.localized_info.map(locale => {
						parentItem.localized_info.push({
							origin_country: locale.origin_country || '-',
							target: locale.target || '-',
							language: locale.language || '-',
							title: locale.title || '-',
							synopsis: locale.synopsis || '-',
							genre: locale.genre || '-',
							type: locale.type || '-'
						})
					})
				}
				edito.push(parentItem)
				if (parent.parent) {
					let grandParentItem = {
						id: parent.parent.id || '-',
						card_type: parent.parent.card_type || '-',
						creation_date: parent.parent.creation_date || '-',
						last_update: parent.parent.last_update || '-',
						title: parent.parent.title || '-',
						title_language: parent.parent.title_language || '-',
						episode_num: parent.parent.episode_num || '-',
						production_year: parent.parent.data.production_year || '-',
						target: parent.parent.data.target || '-',
						genre: parent.parent.data.genre || '-',
						type: parent.parent.data.type || '-',
						synopsis: parent.parent.data.synopsis || '-',
						duration: parent.parent.data.duration || '-',
						casting: parent.parent.data.casting || [],
						localized_info: []
					}
					if (parent.parent.data.localized_info) {
						parent.parent.data.localized_info.map(locale => {
							grandParentItem.localized_info.push({
								origin_country: locale.origin_country || '-',
								target: locale.target || '-',
								language: locale.language || '-',
								title: locale.title || '-',
								synopsis: locale.synopsis || '-',
								genre: locale.genre || '-',
								type: locale.type || '-'
							})
						})
					}
					edito.push(grandParentItem)
				}
			}
			return edito
		},
		locations () {
			let locations = this.$commons.deepGet(this.asset, 'locations', []).map(loc => {
				let storageCategory = loc.storage.category.toLowerCase()
				if (storageCategory === 'chaud') {
					loc.color = 'red'
					loc.icon = 'whatshot'
				} else if (storageCategory === 'froid') {
					loc.color = 'primary'
					loc.icon = 'ac_unit'
				} else if (storageCategory === 'cloud') {
					loc.color = 'teal'
					loc.icon = 'cloud'
				} else if (storageCategory === 'nearline') {
					loc.color = 'deep-purple'
					loc.icon = 'dns'
				} else if (storageCategory === 'physique') {
					loc.color = 'amber'
					loc.icon = 'voicemail'
				} else if (storageCategory === 'data') {
					loc.color = 'blue-grey'
					loc.icon = 'save'
				} else if (storageCategory === 'offline') {
					loc.color = 'grey'
					loc.icon = 'delete_forever'
				} else if (storageCategory === 'catalogue') {
					loc.color = 'info'
					loc.icon = 'library_books'
				} else {
					loc.color = 'white'
					loc.icon = 'help_outline'
				}
				return loc
			})
			return locations
		},
		is_admin () {
			return this.$user.isAdmin()
		}
	},
	methods: {
		keyFormatter (key) {
			return key.replace(/_/g, ' ')
		},
		getter (path) {
			let val = this.$commons.deepGet(this.asset, path, '-')
			if (val === '') val = '-'
			return val
		},
		copyToClipboard (text) {
			let copied = this.$grv_clipboard.copyToClipboard(text)
			if (copied) {
				this.$Toaster({
					title: `Copié`,
					content: text,
					type: 'success',
					loading: false,
					timeout: 1000
				})
			}
		},
		openScreenshots (initialViewIndex) {
			let container = document.createElement('div')
			var promises = []
			for (const screenshot of this.artefacts.screenshots) {
				let image = new Image()
				promises.push(new Promise((resolve, reject) => {
					image.addEventListener('load', function () {
						container.append(this)
						resolve()
					})
					image.addEventListener('error', function () {
						resolve()
					})
				}))
				image.src = this.artefacts.url + screenshot + this.artefacts.signature
				image.title = screenshot.substring(screenshot.lastIndexOf('/') + 1)
			}
			Promise.all(promises)
				.then(() => {
					let img_list = Array.from(container.children)
					img_list.sort((a, b) => {
						return a.title.toLowerCase().localeCompare(b.title.toLowerCase())
					})
					container.innerHTML = ''
					img_list.forEach(img => container.appendChild(img))
					if (container.children.length === 0) return
					this.image_container = container
					this.image_viewer = new Viewer(container, {
						hidden: () => this.closeImageViewer(),
						container: '#screenshot-viewer',
						toolbar: {
							zoomIn: 4,
							zoomOut: 4,
							oneToOne: 4,
							reset: 4,
							prev: 4,
							play: {
								show: 4,
								size: 'large'
							},
							next: 4,
							rotateLeft: 0,
							rotateRight: 0,
							flipHorizontal: 0,
							flipVertical: 0
						}
					})
					container.children[initialViewIndex].click()
					this.image_viewer.show()
				})
				.catch(error => {
					console.error(error)
				})
		},
		closeImageViewer () {
			if (this.image_viewer) {
				this.image_viewer.destroy()
				this.image_viewer = null
			}
			if (this.image_container) {
				this.image_container.remove()
				this.image_container = null
			}
		},
		fetchArtefacts () {
			this.artefacts = null
			if (this.asset.id) {
				this.$EsMaestro.asset_artefacts(this.asset.id)
					.then(artefacts => {
						console.log(artefacts)
						this.artefacts = artefacts
						setTimeout(() => {
							if (Object.keys(artefacts.audio)) {
								for (const key in artefacts.audio) {
									const options = {
										zoomview: {
											container: document.getElementById(`zoomview-${key}`),
											waveformColor: '#84ffff',
											playedWaveformColor: '#7affbf',
											playheadColor: '#84ffff'
										},
										overview: {
											container: document.getElementById(`overview-${key}`),
											waveformColor: '#84ffff',
											playedWaveformColor: '#7affbf',
											highlightColor: '#08161f',
											playheadColor: '#84ffff'
										},
										mediaElement: document.getElementById(`audio-${key}`),
										dataUri: {
											arraybuffer: artefacts.url + artefacts.audio[key].dat + artefacts.signature
										}
									}
									Peaks.init(options, (err, peaks) => {
										if (err) {
											console.error(
												'Failed to initialize Peaks instance: ' + err.message
											)
											return
										}
										const zoomview = peaks.views.getView('zoomview')
										const overview = peaks.views.getView('overview')
										zoomview.setAmplitudeScale(2.0)
										overview.setAmplitudeScale(2.0)
										// Do something when the waveform is displayed and ready
									})
								}
							}
						}, 2000)
					})
					.catch(error => {
						console.log(error)
					})
			}
		}
	},
	mounted () {
		this.fetchArtefacts()
		if (this.tab) this.current_tab = `tab-${this.tab}`
	}
}
</script>

<style lang="stylus" scoped>
table
	width: 100%
	th
	td
		padding: 4px 16px
		height: 36.5px !important
		min-height: 36.5px !important
		vertical-align: middle
	th
		font-weight: normal
		white-space: nowrap
		color: var(--v-color-lighten5)
	tr:not(:last-child)
		border-bottom: 0.5px solid var(--v-background-lighten1)

>>>.v-tabs__item--active
	background-color: var(--v-background-base)
	color: var(--v-primary-base)
	.v-icon
		color: var(--v-primary-base)

>>>.v-tabs__item--disabled
	.v-icon
		color: hsla(0,0%,100%,.3)

>>>.v-tabs__slider-wrapper
	z-index: 4

.v-tabs
	>>>.v-window__container
		max-height: calc(100vh - 270px)
		overflow: auto
		a.link
			.v-icon
				color: var(--v-primary-base) !important
		a.link:hover
			.v-icon
				color: white !important

.location
	border: 1px solid var(--v-background-base)
	padding: 12px
	margin-bottom: 12px

.storage-category
	float: right

.v-card--reveal
	cursor: pointer
	align-items: center
	bottom: 0
	justify-content: center
	text-align: center
	opacity: .5
	position: absolute
	width: 100%

.zoomview
.overview
	width: 1000px
	border: 1px solid var(--v-primary-base)
	margin-top: 4px

.zoomview
	height: 200px

.overview
	height: 100px

audio
	flex-grow: 1
	height: 30px
	background-color: var(--v-primary-base)
	vertical-align: bottom
audio::-webkit-media-controls-panel
	background-color: var(--v-primary-base)
	margin: 0
</style>



// WEBPACK FOOTER //
// src/components/asset.vue